module.exports = __webpack_public_path__ + "static/img/Aandroid.f590713.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aandroid.png
// module id = eONI
// module chunks = 1